import ReactDOM from "react-dom";
import ProgramIndex from '../components/ProgramIndex'; // eslint-disable-line
import Slider from "../components/Slider";
import VideoPlayer from "../components/VideoPlayer";

/**
 * Single Artist Page
 */
const PageSingleArtist =( $ )=>{

	if ( $( 'body' ).hasClass( 'single-artist' ) ) {
		Slider($);
		VideoPlayer($);

		const attachedPrograms = document.getElementById("js-attached-programs");

		ReactDOM.render(
			<ProgramIndex {...attachedPrograms.dataset} />,
			attachedPrograms
		);
	}

};

export default PageSingleArtist;
